import React from 'react';
import './harbour.css';

/*
 * Harbour/Count pill: the small count beside filter tabs and form lists.
 * Tones: active (on the selected tab), default, locked, neutral, neutralZero.
 */
const TONE_CLASS = {
  active: 'harbour-count-pill--active',
  default: '',
  locked: 'harbour-count-pill--locked',
  neutral: 'harbour-count-pill--neutral',
  neutralZero: 'harbour-count-pill--neutral-zero',
};

export default function HarbourCountPill({ count, tone = 'default', className = '' }) {
  const toneClass = TONE_CLASS[tone] || '';
  return <span className={`harbour-count-pill ${toneClass} ${className}`.trim()}>{count}</span>;
}
